import { render, staticRenderFns } from "./pan_upload.vue?vue&type=template&id=3fcc5c74&"
import script from "./pan_upload.vue?vue&type=script&lang=js&"
export * from "./pan_upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports